import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {ActionHandler} from "../../../../infrastructure/handlers/action-handler";
import {LocalStorageUtils} from "../../../../infrastructure/utils/local-storage.utils";
import type {NewSearchWidgetState} from "../../models/new-search-widget.state";
import type {NewSearchWidgetController} from "../../new-search-widget.controller";
import {LOCAL_STORAGE_KEYS} from "../../../../core/consts";

export class NewSearchWidgetClearHandler extends ActionHandler {
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onClearRecent;
  localStorageUtils: LocalStorageUtils;
  state: NewSearchWidgetState;
  controller: NewSearchWidgetController;

  static injectables = [...ActionHandler.injectables, LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.localStorageUtils = localStorageUtils;
  }

  async action(params) {
    this.localStorageUtils.set(LOCAL_STORAGE_KEYS.recentSearches, []);
    this.state.recentSearchListModel.entities = [];
    this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onClearClickEvent, {source: params.source});
  }
}
